export const fetchImage = action => dispatch => {
  dispatch({ type: action.type + "_REQUEST" });
  dispatch({ type: action.type + "_SUCCESS" });
};
